exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.document-field[data-v-d0e0bcae] {\n  /* Your component styles go here */\n}\r\n", ""]);

// exports
